// Sets data-scrolled once the page moves so the floating header can compact itself.
class KStickyHeader extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const threshold = Number(this.getAttribute('threshold') || 24);
    let frame = 0;
    const update = () => this.toggleAttribute('data-scrolled', scrollY > threshold);
    update();
    addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true, signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('k-sticky-header')) customElements.define('k-sticky-header', KStickyHeader);
